import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export function LegalFooter() {
  return (
    <div className="mt-12 pt-6 border-t border-border text-center text-xs text-muted-foreground pb-6">
      <p>&copy; {new Date().getFullYear()} Halftime Scout</p>
      <div className="flex items-center justify-center gap-4 mt-2">
        <a href="/faq.html" className="hover:text-foreground transition-colors">FAQ</a>
        <Link to="/badges" className="hover:text-foreground transition-colors">Badges</Link>
        <Link to="/privacy" className="hover:text-foreground transition-colors">
          Privacy Policy
        </Link>
        <Link to="/terms" className="hover:text-foreground transition-colors">
          Terms of Service
        </Link>
        <a
          href="https://instagram.com/halftimescout"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="hover:text-foreground transition-colors"
        >
          <Instagram className="h-4 w-4" />
        </a>
        <a
          href="https://x.com/halftimescout"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X"
          className="hover:text-foreground transition-colors"
        >
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </a>
      </div>
    </div>
  );
}